@use 'src/global/variables.scss' as var;

c-header {
  border-radius: 8px 8px 0 0;
  background-color: var.$primary-color;
  color: var.$text-color-light;
  padding: 12px; // Todo use variable, also used in message screen
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    font-size: min(max(14px, 4.5vw), 28px);
    line-height: min(max(18px, 5vw), 32px);
    margin: 0;
    color: currentColor;
  }

  .buttons-container {
    display: inline-flex;
  }

  .menu-container {
    position: absolute;
    padding: 10px;
    top: 10%;
    left: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: white;
    border-radius: 16px;
    z-index: 1000;
    border: 1px solid #e0e0e0;
    min-width: fit-content;

    .v-number {
      margin-top: var.$margin;
      margin-bottom: 0;
      font-weight: bold;
      justify-self: center;
      color: #545454;
      font-size: smaller;
    }

    .menu-item {
      color: #3D4657;
      text-decoration: none;

      svg {
        margin-right: 4px;
      }

      i {
        color: red !important;
      }

      &:hover {
        color: crimson;
        font-weight: bold;
        z-index: 1;
        // Future Task Put this in scss variable // Todo Put also box-shadow in variable
        outline: 4px solid #4299e1;
        outline-offset: 2px;
        text-decoration: underline;
      }

      &:focus, &:focus-visible {
        font-weight: bold;
        z-index: 1;
        // Future Task Put this in scss variable // Todo Put also box-shadow in variable
        outline: 4px solid #4299e1;
        outline-offset: 2px;
        text-decoration: underline;
      }
    }
  }

  button {
    background: #3D4657;
    border: none;
    color: currentColor;
    cursor: pointer;
    border-radius: 10px;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    // Firefox on Windows displays an additional border around focused elements
    &::-moz-focus-inner {
      border: 0;
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var.$focus-color;
    }

    i {
      color: currentColor;
      font-size: x-large;
      font-weight: bolder;
    }

    // Double check when changing the size or position of the icons on phones and on IE
    svg {
      position: absolute; // For some reason this is needed for iOS, otherwise svg is not shown
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 32px;
      height: 32px;
    }

    &.restart-bot {
      margin-right: var.$margin;
      svg {
        transform: translate(-50%, -50%) scale(0.7);
      }
    }

    &.minimize-bot {
      margin-right: var.$margin;
      svg {
        transform: translate(-50%, -50%) scale(0.5);
      }
    }

    &.close-bot {
      svg {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    &.menu-bot {
      margin-right: var.$margin;
      margin-left: 10px;
      svg {
        transform: translate(-50%, -50%) scale(0.7);
      }
    }
  }
}

// 1px less than smallest iPad
@media screen and (max-width: 767px) {
  c-header {
    border-radius: 0;
  }
}

.glow-unset {
  box-shadow: unset !important;
}

.glow-inset {
  box-shadow: inset 0 -5px 5px -2px white !important;
  padding: 12px 12px 17px 12px !important;
}
